import type { Payment } from '../app/api/commerce/payments/[id]/list';

export const mapPayment = (payment: Payment): Payment => ({
  ...payment,
  downPayment: {
    ...payment.downPayment,
    current: parseInt(payment.downPayment.current.toFixed(0), 10),
  },
  residual: payment.residual
    ? {
        ...payment.residual,
        current: parseInt((payment.residual.current * 100).toFixed(0), 10),
        min: parseInt((payment.residual.min * 100).toFixed(0), 10),
        max: parseInt((payment.residual.max * 100).toFixed(0), 10),
        step: parseInt((payment.residual.step * 100).toFixed(0), 10),
        default: parseInt((payment.residual.default * 100).toFixed(0), 10),
      }
    : undefined,
});
